import { ResultCard } from '@/components/survey/result/ResultCard';

export function TrackerResult({ recommendations }) {
  return (
    <div className="gap-4 mt-8 space-y-4">
      {recommendations.map((recommendation) => (
        <ResultCard key={recommendation.id} recommendation={recommendation} />
      ))}
    </div>
  );
}
